import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=1c63d18a&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=1c63d18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63d18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c63d18a')) {
      api.createRecord('1c63d18a', component.options)
    } else {
      api.reload('1c63d18a', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=1c63d18a&scoped=true&", function () {
      api.rerender('1c63d18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IBCuvEpl5HYn/JS/comp/DateRange.vue"
export default component.exports